// extracted by mini-css-extract-plugin
export default {"root":"EmptyAuth_root__FXGVP","content":"EmptyAuth_content__Pcx1r","info":"EmptyAuth_info__ccC7e","actions":"EmptyAuth_actions__etZg6"};